module.exports = __webpack_public_path__ + "static/img/A100.43c19c9d.jpg";